
import api from './core';
import { Customer, CustomerStats } from './types';

export const getCustomers = async (signal?: AbortSignal): Promise<Customer[]> => {
  const response = await api.get('/crm/customers/', { signal });
  return response.data;
};

export const getCustomer = async (
  id: string,
  signal?: AbortSignal
): Promise<Customer> => {
  const response = await api.get(`/crm/customers/${id}/`, { signal });
  return response.data;
};

export const getCustomerStats = async (
  id: string,
  signal?: AbortSignal
): Promise<CustomerStats> => {
  const response = await api.get(`/crm/customers/${id}/stats/`, { signal });
  return response.data;
};

export const setActiveCustomer = async (customerId: string): Promise<void> => {
  await api.put(`/crm/customers/active/${customerId}/`);
};
